module.exports = __webpack_public_path__ + "img/me.5934dca9.png";